module.exports = __webpack_public_path__ + "img/mob3.16dd0a7e.png";